import { Box } from "@mui/material";
import AddAddressButton from "./AddAddressButton";

export default function AddAddressButtonSection() {
    return (
        <Box
            position="absolute"
            bottom={0}
            left={0}
            right={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
            height={200}
            sx={{
                background: "linear-gradient(0deg, #FFF 33%, rgba(255, 255, 255, 0.00) 100%);",
                pointerEvents: "none",
            }}
        >
            <AddAddressButton />
        </Box>
    );
}